import { makeAppInstance } from '@zg-rentals/util';

export const appInfo = makeAppInstance<
  | {
      name: string;
      buildNumber: number;
    }
  | undefined
>(() => undefined, '@zg-rentals/app-info:appInfo');

export const gitInfo = makeAppInstance<
  | {
      branch?: string;
      commit: string;
    }
  | undefined
>(() => undefined, '@zg-rentals/app-info:gitInfo');
